import { ApiError } from "../lib/api";
import { Link } from "../lib/router";
import { Paywall } from "./Paywall";

export function LimitNotice({ error }: { error: ApiError; onSignedIn?: () => void }) {
  if (error.code === "NO_ACCESS" || error.code === "SIGN_IN_REQUIRED") return <Paywall />;
  if (error.code === "LIMIT_REACHED") {
    return (
      <div className="notice">
        <p className="notice-title">{error.message}</p>
        <p>{error.data.state === "trial" ? "Trial accounts have a smaller daily allowance. Subscribers get more." : "Your allowance refills on a rolling 24-hour basis."}</p>
        {error.data.state === "trial" && <Link className="btn btn-primary" to="/pricing">See plans</Link>}
      </div>
    );
  }
  return (
    <div className="notice notice-error" role="alert">
      <p className="notice-title">{error.message}</p>
    </div>
  );
}
